import React from 'react'
import { useLocation } from 'react-router'
import { Navigate, Route, Routes as ReactRouterRoutes } from 'react-router-dom'

const BookingScene = React.lazy(() => import('./scenes/BookingScene'))
const NotFoundPage = React.lazy(() => import('./scenes/NotFoundPage'))
const ConnectScene = React.lazy(() => import('./scenes/Connect/Confirmation'))
const InsuranceScene = React.lazy(() => import('./scenes/Connect/Insurance'))

const Routes = () => {
  const location = useLocation()

  return (
    <React.Suspense fallback={<div>init...</div>}>
      <ReactRouterRoutes>
        <Route
          path="/booking"
          element={
            <Navigate
              to={{
                ...location,
                pathname: '/booking/book'
              }}
              replace
            />
          }
        />
        <Route
          path="/"
          element={
            <Navigate
              to={{
                ...location,
                pathname: '/booking/book'
              }}
              replace
            />
          }
        />
        <Route path="booking/*" element={<BookingScene />} />
        <Route path="connect/insurance" element={<InsuranceScene />} />
        <Route path="connect/*" element={<ConnectScene />} />

        <Route element={<NotFoundPage />} />
      </ReactRouterRoutes>
    </React.Suspense>
  )
}

export default Routes
